import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Businesses from './pages/Businesses';
import Jobs from './pages/Jobs';
import Costs from './pages/Costs';
import Configuration from './pages/Configuration';
import ApiKeys from './pages/ApiKeys';
import Settings from './pages/Settings';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="businesses" element={<Businesses />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="costs" element={<Costs />} />
        <Route path="configuration" element={<Configuration />} />
        <Route path="api-keys" element={<ApiKeys />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default App;
